module.exports = __webpack_public_path__ + "img/c6.2367a88e.png";